import toast from 'react-hot-toast';

export default (error: any) => {
  try {
    switch (error.status) {
      case 400:
        toast.error(`Bad request ${error?.data?.message}`, {
          position: 'top-left',
          duration: 5000,
        });
        break;
      case 401:
        try {
          handleOpenConfirmLogoutBox();
          toast.error('authentication failed', {
            position: 'top-left',
            duration: 5000,
          });
        } catch (err) {
          toast.error('authentication failed', {
            position: 'top-left',
            duration: 5000,
          });
        }
        break;
      case 503:
        toast.error('Sorry! Server Error. Please try again.', {
          position: 'top-left',
          duration: 5000,
        });
        break;
      case 500:
        toast.error('Sorry! Server Error. Please try again.', {
          position: 'top-left',
          duration: 5000,
        });
        break;
      case 409:
        toast.error('Duplicated Error', {
          position: 'top-left',
          duration: 5000,
        });
        break;
      case 404:
        toast.error('Request failed , endpoint not found', {
          position: 'top-left',
          duration: 5000,
        });
        break;
      case 403:
        handleOpenConfirmLogoutBox();
        toast.error('Request failed , endpoint not found', {
          position: 'top-left',
          duration: 5000,
        });
        break;
      default:
        toast.error(error.data.message, {
          position: 'top-left',
          duration: 5000,
        });
        break;
    }
  } catch (error) {
    toast.error('No internet connection !', {
      position: 'top-left',
      duration: 5000,
    });
  }
};

const handleOpenConfirmLogoutBox = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('userId');
  window.location.href = '/login';
};
